// extracted by mini-css-extract-plugin
export default {"contenedor":"styles_contenedor__udodj","buttonContainer":"styles_buttonContainer__6G6Wi","texto":"styles_texto__pWpHw"};